import { phone } from "phone";

const parse = (s: string, country: string) => {
  return phone(s, { country }).phoneNumber;
};

export const phone_utils = {
  parse,
};
